module.exports = __webpack_public_path__ + "static/media/St Georges Road Alcove Unit (10).41194739.jpg";